export enum NodeScriptResultMeta {
  MODEL = "nodescriptresult",
}
